module.exports = __webpack_public_path__ + "img/acryl_teaser.18bb421b.jpg";